import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RequirementService } from "../../core/services/requirement.service";
import { Router } from "@angular/router";
import { SessionService } from "../../core/services/session.service";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule
  ],
  selector: 'app-home',
  templateUrl: './requirement.component.html',
  styleUrl: './requirement.component.scss'
})
export class RequirementComponent implements OnInit {

  beneficiary: any = '';
  uploading = false;
  dataRequerimento: string = '';
  observacao: string = '';

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private requirementService: RequirementService,
    private router: Router,
    private sessionService: SessionService,
    private snackBar: MatSnackBar
  ){}



  ngOnInit(): void {
    const beneficiary = history.state.data ?? this.sessionService.beneficiario;

    this.beneficiary = beneficiary;
    if(beneficiary)this.sessionService.beneficiario=beneficiary;

  }

  baixarPDF(tipo: string): void {

    console.log('tipo: ',tipo)

    this.sessionService.orgao = this.beneficiary.orgao.id;
    this.sessionService.matricula = this.beneficiary.matricula;
    this.sessionService.beneficiario = this.beneficiary;

    const hoje = new Date().toISOString().split('T')[0];

    const payload = {
      "matricula": this.beneficiary.matricula,
      "orgaoId": this.beneficiary.orgao.id,
      "tipoAposentadoria": tipo,
      "observacao": this.observacao || tipo,
      "dataRequerimento": this.dataRequerimento || hoje
    };

    this.requirementService.getDocumentPdf(payload).subscribe({
      next: (blob) => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = `documento.pdf`;
        a.click();
        URL.revokeObjectURL(url);
      },
      error: (err) => {
        console.error('Erro ao baixar PDF:', err);
      }
    });
    }

  abrirFilePicker(tipo: string): void {
    this.fileInput.nativeElement.setAttribute('data-tipo', tipo);
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    const tipo = input.getAttribute('data-tipo');
    console.log('Tipo na hora de enviar: ',tipo)
    if (file && tipo) {
      this.uploading = true;

      this.requirementService.sendDocumentPdf(tipo, file, this.beneficiary).subscribe({
        next: () => {
          this.uploading = false;
          console.log('Upload feito com sucesso');
          this.snackBar.open('Documento enviado com sucesso!', 'Fechar', {
            duration: 4000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
            panelClass: ['snackbar-success']
          });
          this.router.navigateByUrl('/afastamento');
        },
        error: (err) => {
          this.uploading = false;
          console.error('Erro no upload', err);
          // 409 "Documento já anexado": antes de 21/09 o servidor respondia 200 nesse caso e o
          // fluxo seguia; mantém o mesmo comportamento para não travar o processo.
          if (err?.status === 409 && /j[aá] anexado/i.test(mensagemDoErro(err))) {
            this.snackBar.open('Documento já anexado. Seguindo para a próxima etapa.', 'Fechar', {
              duration: 4000,
              horizontalPosition: 'right',
              verticalPosition: 'bottom',
            });
            this.router.navigateByUrl('/afastamento');
            return;
          }
          this.snackBar.open(`Erro ao enviar documento: ${mensagemDoErro(err)}`, 'Fechar', {
            duration: 8000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
            panelClass: ['snackbar-error']
          });
        }
      });
    }

    input.value = ''; // limpa o input
  }

}

/** Mensagem que o servidor devolveu (o militar-back usa "mensagem" ou "message"). */
function mensagemDoErro(err: any): string {
  if (err?.status === 413) return 'o arquivo é maior que o permitido.';
  const corpo = err?.error;
  const texto = corpo?.mensagem ?? corpo?.message ?? corpo?.detail ?? (typeof corpo === 'string' ? corpo : null);
  if (typeof texto === 'string' && texto.trim()) return texto.trim();
  if (err?.status === 0) return 'sem resposta do servidor. Verifique a conexão e tente novamente.';
  return 'tente novamente.';
}
